// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__24E-a","approved":"Status_approved__1UM9k","rejected":"Status_rejected__3h_ts","expired":"Status_expired__2doNc","label":"Status_label__bP3uA"};